var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoTopicsCreated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 156,
    viewBox: "0 0 165 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 39.0526,
    height: 39.0526,
    rx: 2,
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.3154,
    y: 5.10526,
    width: 90.3684,
    height: 10.3158,
    rx: 1,
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.3154,
    y: 25.6316,
    width: 39.0526,
    height: 10.3158,
    rx: 1,
    fill: "#FF9D2E",
    fillOpacity: 0.1,
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 58.4737,
    width: 39.0526,
    height: 39.0526,
    rx: 2,
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.1582,
    y: 63.6316,
    width: 28.7368,
    height: 28.7368,
    rx: 2,
    fill: "#FF9D2E",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 52.3154,
    y: 62.5789,
    width: 110.895,
    height: 10.3158,
    rx: 1,
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52.3154,
    y: 83.1053,
    width: 69.8421,
    height: 10.3158,
    rx: 1,
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 115.947,
    width: 39.0526,
    height: 39.0526,
    rx: 2,
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 52.3154,
    y: 120.053,
    width: 100.632,
    height: 10.3158,
    rx: 1,
    fill: "#FF9D2E",
    fillOpacity: 0.1,
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 52.3154,
    y: 140.579,
    width: 80.1053,
    height: 10.3158,
    rx: 1,
    stroke: "#FF9D2E",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTopicsCreated);
export default __webpack_public_path__ + "static/media/noTopicsCreated.a72d35bb0757bfdb0c27af8fb3debd4a.svg";
export { ForwardRef as ReactComponent };